// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFormat.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Format component
 */
import React from 'react';
import { observer } from 'mobx-react';
import FormGroup from 'share/components/controls/Izenda.FormGroup';
import Label from 'share/components/controls/Izenda.Label';
import DropDown from 'share/components/controls/Izenda.DropDown';
import constants from 'logic/data/Izenda.CalculatedFieldConstants';
import { get } from 'lodash/fp';

@observer
class Format extends React.Component {
  static displayName = 'Format';

  /**
   * Handle change of format
   * @param {Object} changed
   * @param {Object} newFormat
   */
  onChangeFormat = (changed: Object, newFormat: Object) => {
    newFormat = newFormat || {};
    this.props.store.clonedModel.changeFormat({
      formatId: newFormat.customId,
      format: newFormat.format || '',
      groupBy: newFormat.groupBy || null,
      formatDataType: newFormat.formatDataType
    });
  };

  render() {
    let {
      localization,
      store: { clonedModel: model },
      type: { name: typeName }
    } = this.props;

    if (typeName !== constants.TYPES.SUB_TOTAL.name && typeName !== constants.TYPES.GRAND_TOTAL.name) {
      return null;
    }
    return (
      <FormGroup className="u_paddingRight">
        <Label className="col-md-3 text-left u_paddingLeft">{localization.getText('COMMON_LABEL_FORMAT')}</Label>
        <div className="col-md-9 u_noPaddingAll">
          <DropDown
            options={model.formats}
            onChange={this.onChangeFormat}
            labelField="name"
            valueField="customId"
            groupBy="category"
            blankOption
            blankOptionText="..."
            value={get('format.formatId', model)}
          />
        </div>
      </FormGroup>
    );
  }
}

export default Format;



// WEBPACK FOOTER //
// ./ui/share/components/controls/calculatedField/Izenda.CalculatedFormat.js